// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartBaseRenderer } from '../TerceraChartBaseRenderer';
import { Pen, PenStyle, SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
export class TerceraChartBaseScaleRenderer extends TerceraChartBaseRenderer {
    constructor(settings, terceraChart) {
        super(terceraChart);
        this.settings = settings;
        // this.Orientation;
        this.SetClassName('TerceraChartBaseScaleRenderer');
    }
    GetPreferredHeight() {
        return this.settings.ScaleFont.Height + 4;
    }
    FormatValue(value) {
        return value.toString();
    }
}
export class TerceraChartBaseScaleRendererSettings {
    constructor() {
        this.AutoScaleSwitcherVisible = false;
        this.scaleGridColor = ThemeManager.colors.chartGridColor;
        this.scaleGridStyle = PenStyle.IsoDotChart;
        this.scaleGridWidth = 1;
        this.scaleGridPen = new Pen(this.scaleGridColor, this.scaleGridWidth, PenStyle.ShapedChart);
        this.ScaleGridVisibility = true;
        this.scaleAxisColor = ThemeManager.colors.Chart_PriceScaleAxisColor;
        this.scaleAxisPen = new Pen(this.scaleAxisColor, 1);
        this.scaleBackColor = ThemeManager.colors.Chart_ScalesBackColor;
        this.scaleBackBrush = new SolidBrush(this.scaleBackColor);
        this.scaleBackBrushShadow = new SolidBrush(ThemeManager.colors.Chart_PriceScaleBackColorSdadow);
        this.scaleTextColor = ThemeManager.colors.Chart_ScalesTextColor;
        this.scaleTextBrush = new SolidBrush(this.scaleTextColor);
        this.ScaleFont = ThemeManager.Fonts.Font_12F_regular.copy();
    }
    get ScaleGridColor() {
        return this.scaleGridColor;
    }
    set ScaleGridColor(value) {
        this.scaleGridColor = value;
        this.scaleGridPen.Color = value;
    }
    get ScaleGridStyle() {
        return this.scaleGridStyle;
    }
    set ScaleGridStyle(value) {
        this.scaleGridStyle = value;
        this.scaleGridPen.DashStyle = this.scaleGridStyle;
    }
    get ScaleGridWidth() {
        return this.scaleGridWidth;
    }
    set ScaleGridWidth(value) {
        this.scaleGridWidth = value;
        this.scaleGridPen.Width = this.scaleGridWidth;
        this.scaleGridPen.DashStyle = this.scaleGridStyle;
    }
    get ScaleBackColor() {
        return this.scaleBackColor;
    }
    set ScaleBackColor(value) {
        this.scaleBackColor = value;
        this.scaleBackBrush.Color = value;
    }
    get ScaleTextColor() {
        return this.scaleTextColor;
    }
    set ScaleTextColor(value) {
        this.scaleTextColor = value;
        this.scaleTextBrush.Color = value;
    }
    ThemeChanged() {
        this.ScaleBackColor = ThemeManager.colors.Chart_ScalesBackColor;
        this.ScaleTextColor = ThemeManager.colors.Chart_ScalesTextColor;
        this.ScaleGridColor = ThemeManager.colors.chartGridColor;
    }
    setScaleBackColor(color) {
        this.scaleBackColor = color;
        this.scaleBackBrush.Color = color;
    }
    setScaleAxisColor(color) {
        this.scaleAxisColor = color;
        this.scaleAxisPen.Color = color;
    }
    Properties() {
        return [];
    }
    callBack(properties) { }
}
